import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react';
import type { ApiCity } from '~/src/services/api/api-content/geography/types';
import { IBundlePackage, IInternetPackage } from '~/src/services/api/api-content/cities/types';

export interface ITariffContextState {
    bundles: IBundlePackage[];
    mono: IInternetPackage[];
    stage: ERequestStages;
}
interface ILandingContext {
    city?: ApiCity;
    ymUid?: string;
    token?: string;
    enableCaptcha: boolean;
    enableWebp: boolean;
}
interface ICommonLandingContext extends ILandingContext{
    tariffs: [ITariffContextState, Dispatch<SetStateAction<ITariffContextState>>];
}

export enum ERequestStages {
    init = 'init',
    error = 'error',
    loaded = 'loaded',
    loading = 'loading',
    requestSended = 'requestSended',
}
interface IContextContainer extends ILandingContext {
    children: JSX.Element | JSX.Element[];
}
const INITIAL_STATE_TARIFF = {
    bundles: [],
    mono: [],
    stage: ERequestStages.init,
};
export const LandingContext = createContext<ICommonLandingContext>({
    city: undefined,
    ymUid: undefined,
    token: undefined,
    enableCaptcha: false,
    enableWebp: false,
    tariffs: [INITIAL_STATE_TARIFF, () =>({})],
});

const ContextContainer = ({ city, enableCaptcha, enableWebp, ymUid, children, token }: IContextContainer): JSX.Element => {
    const tariffs = useState(INITIAL_STATE_TARIFF);

    const value = useMemo(
        () => ({ city, enableCaptcha, ymUid, enableWebp, tariffs, token }),
        [city, enableCaptcha, enableWebp, tariffs, ymUid, token]
    );

    return (
        <LandingContext.Provider value={value}>
            {children}
        </LandingContext.Provider>
    );
};

export default ContextContainer;
